export const colorsSeparator = Object.freeze({
  'basel': 'basel',
  'miami-beach': 'miami',
  'hong-kong': 'hongkong',
  'cities': 'cities',
  'paris': 'paris'
})

export default colorsSeparator
